import type { InputSource } from '../types';
import { createBorder } from '../utils/create-border';
import { drawDisguiseLogo } from '../utils/draw-disguise-logo';

export function drawCalibrationGrid(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  x = 0,
  y = 0,
  invert = false
) {
  ctx.fillStyle = invert ? 'black' : 'white';
  ctx.fillRect(x, y, width, height);

  createBorder(ctx, x, y, width, height, 4);

  // Draw grid lines
  ctx.strokeStyle = '#bdbdbd';
  ctx.lineWidth = 1;
  const gridDivs = 10;
  for (let i = 0; i <= gridDivs; i++) {
    ctx.beginPath();
    ctx.moveTo(x + (i * width) / gridDivs, y);
    ctx.lineTo(x + (i * width) / gridDivs, y + height);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(x, y + (i * height) / gridDivs);
    ctx.lineTo(x + width, y + (i * height) / gridDivs);
    ctx.stroke();
  }

  // Draw center lines (thicker)
  ctx.strokeStyle = '#bdbdbd';
  ctx.lineWidth = 3;
  ctx.beginPath();
  ctx.moveTo(x + width / 2, y);
  ctx.lineTo(x + width / 2, y + height);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(x, y + height / 2);
  ctx.lineTo(x + width, y + height / 2);
  ctx.stroke();

  // Draw center circle
  ctx.strokeStyle = '#bdbdbd';
  ctx.lineWidth = 1.5;
  const circleRadius = height / 2;
  ctx.beginPath();
  ctx.arc(x + width / 2, y + height / 2, circleRadius, 0, 2 * Math.PI);
  ctx.stroke();

  drawDisguiseLogo(ctx, width, height, x, y, invert ? 'white' : 'black');
}

export const calibrationGrid: InputSource = {
  label: 'Calibration Grid',
  value: 'calibrationGrid',
  draw: (ctx, width, height) => {
    drawCalibrationGrid(ctx, width, height, 0, 0, false);
  },
};

export const calibrationGridInverted: InputSource = {
  label: 'Calibration Grid (Inv)',
  value: 'calibrationGridInverted',
  draw: (ctx, width, height) => {
    drawCalibrationGrid(ctx, width, height, 0, 0, true);
  },
};
